(function () {
  var handle = window.__productHandle;
  if (!handle) return;

  function getSelectedVariantId() {
    var idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function updateInventory() {
    var selectedId = getSelectedVariantId();
    if (!selectedId) return;

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variant = product.variants.find(function (v) {
          return v.id === selectedId;
        });
        if (!variant) return;

        var available = variant.available;
        var qty = variant.inventory_quantity;
        var managed = variant.inventory_management === 'shopify';
        var deny = variant.inventory_policy === 'deny';

        // 1. Update quantity input max
        var qtyInput = document.querySelector('form[action="/cart/add"] input[name="quantity"]');
        if (qtyInput && managed && deny) {
          qtyInput.max = qty;
        }

        // 2. Update Add to Cart / Not in Stock button
        var submitBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');
        if (submitBtn) {
          submitBtn.classList.toggle('disabled', !available);
          submitBtn.disabled = !available;
        }

        // 3. Update submit wrapper unavailable class
        var submitP = document.querySelector('form[action="/cart/add"] p.submit');
        if (submitP) {
          submitP.classList.toggle('unavailable', !available);
        }

        // 4. Update stock display
        var stockEl = document.querySelector('.f8pr-stock .stock');
        if (stockEl) {
          stockEl.classList.toggle('overlay-valid', available);
          stockEl.classList.toggle('overlay-error', !available);

          // Update stock count text node
          var textNode = Array.from(stockEl.childNodes).find(function(n) {
            return n.nodeType === 3;
          });
          if (textNode) {
            textNode.textContent = (available && qty > 0) ? qty + ' In Stock ' : '';
          }
        }
      })
      .catch(function (err) {
        console.warn('Live inventory update failed:', err);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Run immediately on load
    updateInventory();

    // Watch for variant changes via MutationObserver on the hidden ID input
    var idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (idInput) {
      var observer = new MutationObserver(function () {
        updateInventory();
      });
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Also catch direct change events as a fallback
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('form[action="/cart/add"]'))) {
        setTimeout(updateInventory, 100);
      }
    });
  });
})();